import { useState } from "react";
import { IonItem } from "@ionic/react";
import { SchoolHoursModel, ShortenedDays } from "model";

import { translate } from "~utils";

import { EditableHours } from "../EditableFields";
import { useUpdateSchool } from "./hooks";
import { Footer, ProfileCard } from "./ProfileCard";
import { ErrorList, SchoolScheduleFormSchema } from "./SchoolProfileFormUtils";

type SchoolDetailsProps = { hours: SchoolHoursModel; schoolId: string };

export const SchoolDetails = ({ hours, schoolId }: SchoolDetailsProps) => {
  const [editingHours, setEditingHours] = useState(hours);

  const onEditHours = (value: number, day: ShortenedDays, slot: "start" | "end") => {
    const setDay = {
      day: day,
      start: slot === "start" ? value : editingHours[day]["start"],
      end: slot === "end" ? value : editingHours[day]["end"],
    };
    setEditingHours(new SchoolHoursModel(editingHours.updateHours(setDay)));
  };

  const formState = {
    hours: editingHours.schoolHours,
  };

  const { errors, updateSchool } = useUpdateSchool({
    formState,
    validationSchema: SchoolScheduleFormSchema,
    schoolId,
  });

  const onSave = () => {
    updateSchool().then(() => {
      setEditing(false);
    });
  };

  const [editing, setEditing] = useState(false);

  return (
    <ProfileCard
      header={translate("SCHOOL_SCHEDULE_LABEL")}
      isEditing={editing}
      onClick={() => setEditing(true)}
    >
      <IonItem lines="none" className="pb-4">
        <EditableHours
          editing={editing}
          value={editingHours}
          onChange={(value, day, slot) => {
            onEditHours(value, day, slot);
          }}
        />
      </IonItem>
      {editing && (
        <>
          {errors.length > 0 && (
            <IonItem lines="none">
              <ErrorList errorList={errors} />
            </IonItem>
          )}

          <Footer onSubmit={onSave} onCancel={() => setEditing(false)} />
        </>
      )}
    </ProfileCard>
  );
};
